var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBodyPart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64832 1.875C8.64832 2.91016 7.80597 3.75 6.76772 3.75C5.72948 3.75 4.88713 2.91016 4.88713 1.875C4.88713 0.839844 5.72948 0 6.76772 0C7.80597 0 8.64832 0.839844 8.64832 1.875ZM6.45429 13.75V18.75C6.45429 19.4414 5.89403 20 5.20056 20C4.50709 20 3.94683 19.4414 3.94683 18.75V10.0352L2.82631 11.8945C2.46978 12.4844 1.69795 12.6758 1.10634 12.3203C0.514738 11.9648 0.322761 11.1953 0.679291 10.6055L2.96343 6.81641C3.64515 5.6875 4.86754 4.99609 6.18787 4.99609H7.35149C8.67183 4.99609 9.89422 5.6875 10.5759 6.81641L12.8601 10.6055C13.2166 11.1953 13.0246 11.9648 12.433 12.3203C11.8414 12.6758 11.0696 12.4844 10.7131 11.8945L9.58862 10.0352V18.75C9.58862 19.4414 9.02836 20 8.33489 20C7.64142 20 7.08116 19.4414 7.08116 18.75V13.75H6.45429Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBodyPart);
export default __webpack_public_path__ + "static/media/icon-bodyPart.55eca047221149685dec7dd144b37899.svg";
export { ForwardRef as ReactComponent };